
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnDestroy, QueryList, ViewChildren, ViewEncapsulation } from "@angular/core";
import { Evaluator } from 'formiojs/utils/utils';
import { SortHelper } from '../../../helpers/sort.helper';
import { IndicatorDomain, IndicatorQuestions, IndicatorStatus } from '../models/indicator.model';
import { map, Subscription, switchMap } from 'rxjs';
import _cloneDeep from 'lodash/cloneDeep';
import { FormioLoader, ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-indicator',
    templateUrl: './indicator.component.html',
    // styleUrls: ['./indicator.component.scss']
    encapsulation: ViewEncapsulation.None,
    // providers: [FormioLoader]
})
export class IndicatorComponent implements OnDestroy {
    @ViewChildren('forms') forms: QueryList<any>;

    domainQuery = '';
    questionQuery = '';
    indicatorStatus = IndicatorStatus;
    isSummary = false;
    ready = false;

    domainsDecisions = [];
    orginalDomains = [];

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    constructor(
        public dialogRef: MatDialogRef<IndicatorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formioLoader: FormioLoader,
        private resourceNameService: ResourceNameService) {
        this.domainQuery = Evaluator.interpolate(this.data.customOptions.domainQuery, { data: this.data.submission, indicator: this.data.indicator });
        this.getIndicatorDomains();
        this.isSummary = this.data.isSummary;
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

    close(): void {
        // this.dialogRef.close();
        this.data.indicator.domains.forEach(domain => {
            domain.attachmentsInstance = _cloneDeep(domain.attachments);
        });
        this.orginalDomains.forEach((domain, index) => {
            const item = this.data.indicator.domains.find(q => q.id == domain.id);
            if (item) this.orginalDomains[index] = { ...item };
        })
        this.data.indicator.domains = this.orginalDomains;
        this.dialogRef.close(this.data.indicator);
    }

    async save(domainIndex: number, expansion: any): Promise<void> {
        this.data.indicator.domains[domainIndex].decision = this.domainsDecisions[domainIndex];
        const someNotComplete = this.data.indicator.domains.some(q => q.decision == IndicatorStatus.NotComplete);
        if (someNotComplete) {
            this.data.indicator.status = IndicatorStatus.NotComplete;
        } else {
            const someNotComplete = this.data.indicator.domains.every(q => q.decision == IndicatorStatus.Completed);
            if (someNotComplete) this.data.indicator.status = IndicatorStatus.Completed;
        }

        this.data.indicator.domains[domainIndex].attachments = this.forms
            .find(form => form.id == this.data.indicator.domains[domainIndex].id)
            .formio.data.attachments;

        this.formioLoader.loading = true;
        await this.updateIndicator();
        await this.updateDomain(this.data.indicator.domains[domainIndex]);
        this.formioLoader.loading = false;
        expansion.expanded = false;
    }

    formLoad(formSettings) {
        setTimeout(() => {
            const array = $('.indicator [name="data[submit]"]');
            for (let index = 0; index < array.length; index++) {
                $(array[index]).hide();
            }
        }, 250)
    }

    updateDomains(isAll = false) {
        if (!isAll) {
            this.data.indicator.domains = this.data.indicator.domains.filter(q => q.decision != IndicatorStatus.Completed);
        }
        this.data.isSummary = false;
    }

    private getIndicatorDomains() {
        if (this.data.indicator.isCached) {
            this.fillDomainsDecisions();
            this.formioLoader.loading = false;
            this.ready = true;
            this.orginalDomains = _cloneDeep(this.data.indicator.domains);
            return;
        }

        this.formioLoader.loading = true;
        this.sub = this.resourceNameService.loadCustomByFilterdKey(this.data.customOptions.domainResource, this.domainQuery)
            .pipe(
                map((data: any[]) => {
                    return SortHelper.recursiveSort(data, 'asc').map(q => {
                        const item = new IndicatorDomain(q._id, q.data.key, q.data.domainNumber, q.data.descriptionValue, q.data.order);
                        return item;
                    })
                }),
                switchMap(data => {
                    this.data.indicator.domains = data;
                    this.questionQuery = Evaluator.interpolate(this.data.customOptions.questionQuery, { data: this.data.submission, indicator: this.data.indicator });
                    return this.resourceNameService.loadCustomByFilterdKey(this.data.customOptions.questionResource, this.questionQuery)
                }),
                map((data: any[]) => {
                    return SortHelper.recursiveSort(data, 'asc').map(q => {
                        const item = new IndicatorQuestions(q._id, q.data.order, q.data.descriptionValue, q.data.key, q.data.indicatorDomainKey);
                        item.answer = 0;
                        return item;
                    })
                }))
            .subscribe(data => {
                this.data.indicator.domains.forEach(domain => {
                    domain.questions = data.filter(q => q.domainKey == domain.key);
                });

                const domainsId = this.data.indicator.domains.map(q => q.id).join();
                const query = `data.requestId=${this.data.indicator.requestId}&data.indicatorId=${this.data.indicator.id}&data.domainId__in=${domainsId}`;
                this.sub = this.resourceNameService.loadCustomByFilterdKey(this.data.customOptions.domainResult, query)
                    .subscribe(domains => {
                        this.mapDomains(this.data.indicator.domains, domains);
                        this.fillDomainsDecisions();
                        this.data.indicator.isCached = true;
                        this.orginalDomains = _cloneDeep(this.data.indicator.domains);
                        this.formioLoader.loading = false;
                        this.ready = true;
                    }, error => {
                        this.formioLoader.loading = false;
                    });
            }, error => {
                this.formioLoader.loading = false;
            });
    }

    private fillDomainsDecisions() {
        this.data.indicator.domains.forEach(domain => {
            this.domainsDecisions.push(domain.decision);
        });
    }

    private mapDomains(domains, dataResult) {
        domains.forEach(q => {
            const index = dataResult.findIndex(d => d.data.domainId == q.id);
            if (index >= 0) {
                q.resultSubmissionId = dataResult[index]._id;
                q.decision = dataResult[index].data.decision;
                q.notes = dataResult[index].data.notes;
                q.recommendations = dataResult[index].data.recommendations;
                q.attachments = _cloneDeep(dataResult[index].data.attachments || []);
                q.attachmentsInstance = _cloneDeep(dataResult[index].data.attachments || []);
                q.questions.forEach(question => {
                    const questIndex = dataResult[index].data.questions.findIndex(q => q.id == question.id);
                    if (questIndex >= 0) question.answer = dataResult[index].data.questions[questIndex].answer;
                });
            }
        });
    }

    private async updateIndicator() {
        const model = {
            submissionId: this.data.indicator.submissionId,
            requestId: this.data.indicator.requestId,
            indicatorId: this.data.indicator.id,
            status: this.data.indicator.status,
        };
        this.data.indicator.resultSubmissionId = await this.addOrEdit(this.data.indicator.resultSubmissionId,
            model,
            this.data.customOptions.indicatorResult);
    }
    private async updateDomain(domain: IndicatorDomain) {
        const model = {
            submissionId: this.data.indicator.submissionId,
            requestId: this.data.indicator.requestId,
            indicatorId: this.data.indicator.id,
            domainId: domain.id,
            decision: domain.decision,
            notes: domain.notes,
            recommendations: domain.recommendations,
            attachments: domain.attachments,
            questions: domain.questions.map(q => {
                return {
                    id: q.id,
                    answer: q.answer
                };
            })
        };
        domain.resultSubmissionId = await this.addOrEdit(domain.resultSubmissionId,
            model,
            this.data.customOptions.domainResult);
    }

    private addOrEdit(submissionId: string, obj, resource: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            try {
                if (submissionId) {
                    const result = await this.resourceNameService.editSubmission(resource, submissionId, { data: obj }).toPromise();
                    resolve(submissionId);
                }
                else {
                    const result = await this.resourceNameService.addSubmission(resource, { data: obj }).toPromise();
                    resolve(result._id);
                }
            } catch (e) {
                this.formioLoader.loading = false;
                reject(e);
            }
        });
    }
}
